import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations/flags';

export const visibilityCondition = ({ permissionsMap, accountConfig }) =>
    permissionsMap['BUDGET_MANAGEMENT_VIEW'] &&
    (accountConfig?.[FEATURE_FLAGS.BILLING_AND_PAYMENTS_MODULE_ENABLED] === 'true' ||
        permissionsMap['ADS_CONSOLE_NATIVE_BILLING_AND_PAYMENTS_MODULE']);
